//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "../../../../../components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        AQTooltip
    },
    props: {},
    data() {
        return {
            tooltipHeader: "Header",
            tooltipText: "Tooltip text",
            directionList: ["top", "right", "left", "bottom"],
            directionValue: "top"
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        changeDirection(s) {
            this.directionValue = s;
        }
    }
};
